import React, { useEffect, useState } from 'react'
import SideBar from '../Sidebar/SideBar';
import ClientSubscriptionApi from '../../Api/ClientSubscription';
import { Icon } from '@iconify/react/dist/iconify.js';
import Branches from '../../Api/Branches';
import Package from '../../Api/Package';
import SearchableDropdown from './SearchableDropdown';
import Swal from "sweetalert2";

const ClientSubscription = () => {

    const today = () => new Date().toISOString().slice(0, 10);

    const [itemId, setItemId] = useState();
    const [branchId, setBranchId] = useState('');
    const [packageId, setPackageId] = useState('');
    const [startDate, setStartDate] = useState(today());
    const [expiryDate, setExpiryDate] = useState(today());
    const [status, setStatus] = useState('Use');
    const [branchOptions, setBranchOptions] = useState([]);
    const [packageOptions, setPackageOptions] = useState([]);

    const [data, setData] = useState([]);

    // BranchId, packageId, strt_dt, Exp_Dt, Status 

    console.log("branchId", branchId);
    console.log("packageId", packageId);
    console.log("startDate", startDate);
    console.log("expiryDate", expiryDate);
    console.log("status", status);
    const [formattedStartDate, setFormattedStartDate] = useState('');
    const [formattedExpiryDate, setFormattedExpiryDate] = useState('');

    function formatIsoDate(isoDate) {
        if (typeof isoDate !== 'string' || !isoDate) {
            throw new Error("Invalid input: Please provide a valid ISO date string.");
        }
        // Extract the date part from the ISO string
        return isoDate.substring(0, 10); // Returns "yyyy-MM-dd"
    }

    useEffect(() => {
        if (startDate) {
            setFormattedStartDate(formatIsoDate(startDate));
        }
        if (expiryDate) {
            setFormattedExpiryDate(formatIsoDate(expiryDate));
        }
    }, [startDate, expiryDate]);

    const handleSave = async () => {
        const data = {
            branchId,
            packageId,
            startDate,
            expiryDate,
            status
        }
        const response = await ClientSubscriptionApi.CreateClientSubscription(data)
        if (response) {
            console.log("response", response);
            fetchData()
        }
    }

    const handleUpdate = async () => {

        const data = {
            BranchId: branchId,
            packageId: packageId,
            strt_dt: startDate,
            Exp_Dt: expiryDate,
            Status: status
        }
        const response = await ClientSubscriptionApi.UpdateClientsSubscriptionByid(itemId, data);
        if (response.StatusCode === 200) {
            console.log("response", response);
            Swal.fire({ title: "Updated", text: "Updated Successfully", icon: "success", width: "320px" });
            setItemId(null);
            setBranchId('');
            setPackageId('');
            setStartDate(today());
            setExpiryDate(today());
            setStatus('Use');
            fetchData()
        }
    }


    const handleEdit = (item) => {
        console.log("item", item);
        setItemId(item.id)
        setBranchId(item.BranchId)
        setPackageId(item.packageId)
        setStartDate(item.strt_dt)
        setExpiryDate(item.Exp_Dt)
        setStatus(item.Status)
        console.log(`Edit item with id ${item.id}`);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete this subscription?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete",
            cancelButtonText: "No, keep it",
            reverseButtons: true,
            width: "340px",
        });

        if (!result.isConfirmed) return;

        const response = await ClientSubscriptionApi.DeleteClientsSubscriptionByid(id);
        if (response.StatusCode === 200) {
            Swal.fire({ title: "Deleted", text: "Deleted Successfully", icon: "success", width: "320px" });
            fetchData()
        }
        // setData(data.filter(item => item.id !== id));
    };


    const fetchData = async () => {
        const response = await ClientSubscriptionApi.GetAllClientsSub()
        if (response) {
            console.log("response", response);
            setData(response.Result)
        }
    }

    const fetchDropdownData = async () => {
        const [branchResponse, packageResponse] = await Promise.all([
            Branches.GetAllClients(1, 500, "All", ""),
            Package.GetAllPackage(),
        ]);

        if (branchResponse?.Result) {
            setBranchOptions(branchResponse.Result);
        }

        if (packageResponse?.Result) {
            setPackageOptions(packageResponse.Result);
        }
    };

    useEffect(() => {
        fetchData();
        fetchDropdownData();
    }, []);

    const getBranchName = (id) => {
        const branch = branchOptions.find((item) => String(item.id) === String(id));
        return branch ? branch.branchName : id;
    };

    const getPackageName = (id) => {
        const pkg = packageOptions.find((item) => String(item.id) === String(id));
        return pkg ? pkg.name : id;
    };

    const convertToGMT530 = (isoString) => {
        const d = new Date(isoString);
        const day = String(d.getUTCDate()).padStart(2, '0');
        const month = String(d.getUTCMonth() + 1).padStart(2, '0');
        const year = d.getUTCFullYear();

        return `${day}-${month}-${year}`;
    };


    return (
        <div className='Flex-general-client-sidebar'>
            <div className='sidebar-gen-width'>
                <SideBar />
            </div>
            <div className='Main-general-Client'>
                <div className='header-general'>
                    <h2 className='general-card-title'>Client Subscription</h2>
                </div>
                <div className="control_radius">
                    {/* <div className="company_info-text-im depart_top">Report Template Setting</div> */}
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <div className="input-box-mok1">
                                    <SearchableDropdown
                                        options={branchOptions}
                                        value={branchId}
                                        onChange={(id) => setBranchId(id)}
                                        labelField="branchName"
                                        valueField="id"
                                        placeholder="Select Branch"
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <SearchableDropdown
                                        options={packageOptions}
                                        value={packageId}
                                        onChange={(id) => setPackageId(id)}
                                        labelField="name"
                                        valueField="id"
                                        placeholder="Select Package"
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="date" name="" onChange={(e) => setStartDate(e.target.value)} value={formattedStartDate} required />
                                    <label class="modify_lbl_text3">Start Date</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="date" name="" onChange={(e) => setExpiryDate(e.target.value)} value={formattedExpiryDate} required />
                                    <label class="modify_lbl_text3">Expiry Date</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <select className="modify_im_input mode_category1" value={status}
                                        type="text" name="reportType" onChange={(e) => setStatus(e.target.value)} required >
                                        <option value={'Use'}>Use</option>
                                        <option value={'In Stock'}>In Stock</option>
                                        <option value={'Expired'}>Expired</option>
                                    </select>
                                    <label class="modify_lbl_text3">Status</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ButtonTabSave">
                        {
                            itemId ? (
                                <button
                                    id="SaveBtnMain"
                                    className={`update-button-main-save hovered`}
                                    onClick={handleUpdate}
                                >
                                    Update
                                </button>
                            ) : (
                                <button
                                    id="SaveBtnMain"
                                    className={`save-button-main-save hovered`}
                                    onClick={handleSave}
                                >
                                    Save
                                </button>
                            )
                        }
                    </div>

                    <div className="company_info-text-im depart_top">Client Subscription List</div>
                    <div className="control_radius">
                        <div className="table-account-manager">
                            <table className='table-master-acc'>
                                <thead className='header-table-account'>
                                    <tr>
                                        <th className='table-header-manager ac-sno-wth'>S.No</th>
                                        {/* <th className='table-header-manager'>Id</th> */}
                                        <th className='table-header-manager'>Branch Name</th>
                                        <th className='table-header-manager'>Package Name</th>
                                        {/* <th className='table-header-manager'> Creation Date</th> */}
                                        <th className='table-header-manager'> Start Date</th>
                                        <th className='table-header-manager'> Expiry Date</th>
                                        <th className='table-header-manager'> Status</th>
                                        <th className='table-header-manager'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, idx) => (
                                        <tr key={item.id}>
                                            <td className='table-data-account ac-sno-wth'>{idx + 1}</td>
                                            {/* <td className='table-data-account'>{item.id}</td> */}
                                            <td className='table-data-account'>{getBranchName(item.BranchId)}</td>
                                            <td className='table-data-account'>{getPackageName(item.packageId)}</td>
                                            {/* <td className='table-data-account'>{item.cr_dt}</td> */}
                                            <td className='table-data-account'>{convertToGMT530(item.strt_dt)}</td>
                                            <td className='table-data-account'>{convertToGMT530(item.Exp_Dt)}</td>
                                            <td className='table-data-account'>{item.Status}</td>
                                            <td className='table-data-account'>
                                                <button className="edit-btn-acc" onClick={() => handleEdit(item)}><Icon icon="lucide:edit" /></button>
                                                <button className="delete-btn-acc" onClick={() => handleDelete(item.id)}><Icon icon="material-symbols:delete" /></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ClientSubscription;
